var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "Subheader",
                {
                  attrs: { search: "aliases", title: "Aliases" },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clickAddAlias()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(_vm._s(_vm.$t("Button.Add_Alias")) + "\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.aliasHeaders,
                  items: _vm.analyteData.Aliases,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.AliasName)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.Method)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickSetAsNewAnalyte(
                                          props.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { color: "success" },
                                      },
                                      [_vm._v("call_split")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "text-none" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Button.Set_As_Analyte"))
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickEdit(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { color: "warning" },
                                      },
                                      [_vm._v("edit")]
                                    ),
                                    _vm._v(
                                      _vm._s(_vm.$t("Button.Edit")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickDeleteAlias(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { color: "error" },
                                      },
                                      [_vm._v("delete_forever")]
                                    ),
                                    _vm._v(
                                      _vm._s(_vm.$t("Button.Remove")) +
                                        "\n              "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("AnalyteAliaManagement.addTitleMsg"))),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-radio-group",
                  {
                    attrs: { label: "" },
                    model: {
                      value: _vm.addAliasType,
                      callback: function ($$v) {
                        _vm.addAliasType = $$v
                      },
                      expression: "addAliasType",
                    },
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        label: "Create a new analyte alias",
                        value: true,
                      },
                    }),
                    _vm._v(" "),
                    _c("v-radio", {
                      attrs: {
                        label: "Demote another existing analyte to an alias",
                        value: false,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.addAliasType
                  ? _c("v-autocomplete", {
                      attrs: {
                        label: "Existing analyte:",
                        items: _vm.MasterAnalyteList,
                        "item-text": "AnalyteName",
                        "return-object": "",
                      },
                      model: {
                        value: _vm.mergeAnalyte,
                        callback: function ($$v) {
                          _vm.mergeAnalyte = $$v
                        },
                        expression: "mergeAnalyte",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.addAliasType
                  ? [
                      _c("v-text-field", {
                        attrs: { label: "Alias name" },
                        model: {
                          value: _vm.aliasData.AliasName,
                          callback: function ($$v) {
                            _vm.$set(_vm.aliasData, "AliasName", $$v)
                          },
                          expression: "aliasData.AliasName",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Method" },
                        model: {
                          value: _vm.aliasData.Method,
                          callback: function ($$v) {
                            _vm.$set(_vm.aliasData, "Method", $$v)
                          },
                          expression: "aliasData.Method",
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                !_vm.addAliasType
                  ? _c(
                      "v-btn",
                      {
                        attrs: { color: "add", dark: "" },
                        on: {
                          click: function ($event) {
                            return _vm.addAliasFromAnalyte()
                          },
                        },
                      },
                      [
                        _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                        _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                      ],
                      1
                    )
                  : _c(
                      "v-btn",
                      {
                        attrs: { color: "add", dark: "" },
                        on: {
                          click: function ($event) {
                            return _vm.addAlias()
                          },
                        },
                      },
                      [
                        _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                        _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addDialog,
          callback: function ($$v) {
            _vm.addDialog = $$v
          },
          expression: "addDialog",
        },
      }),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(_vm._s(_vm.$t("AnalyteAliaManagement.editTitleMsg"))),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("v-text-field", {
                  attrs: { label: "Name:" },
                  model: {
                    value: _vm.editAliases.AliasName,
                    callback: function ($$v) {
                      _vm.$set(_vm.editAliases, "AliasName", $$v)
                    },
                    expression: "editAliases.AliasName",
                  },
                }),
                _vm._v(" "),
                _c("v-text-field", {
                  attrs: { label: "Method:" },
                  model: {
                    value: _vm.editAliases.Method,
                    callback: function ($$v) {
                      _vm.$set(_vm.editAliases, "Method", $$v)
                    },
                    expression: "editAliases.Method",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "add", dark: "" },
                    on: {
                      click: function ($event) {
                        return _vm.editAlias()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.editDialog,
          callback: function ($$v) {
            _vm.editDialog = $$v
          },
          expression: "editDialog",
        },
      }),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("Button.Delete_Alias")))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("v-card-text", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("AnalyteAliaManagement.deleteTitleMsg", {
                        msg: _vm.deleteAliasData.AliasName,
                      })
                    )
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "delete", dark: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.deleteAlias()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [
                      _vm._v("delete_forever"),
                    ]),
                    _vm._v(_vm._s(_vm.$t("Button.REMOVE_ALIAS")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.CANCEL")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.configDialog,
          callback: function ($$v) {
            _vm.configDialog = $$v
          },
          expression: "configDialog",
        },
      }),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("Button.Set_As_Analyte")))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("v-card-text", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("AnalyteAliaManagement.setTitleMsg", {
                        analyteName: _vm.newAnalyteAlias.AliasName,
                      })
                    )
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "add", dark: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.SetAsNewAnalyte()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(
                      _vm._s(_vm.$t("Button.SET_AS_ANALYTE")) + "\n      "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.CANCEL")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.setAsNewAnalyteDialog,
          callback: function ($$v) {
            _vm.setAsNewAnalyteDialog = $$v
          },
          expression: "setAsNewAnalyteDialog",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }